"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class ERC20__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(name_, symbol_, overrides) {
        return super.getDeployTransaction(name_, symbol_, overrides || {});
    }
    deploy(name_, symbol_, overrides) {
        return super.deploy(name_, symbol_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.ERC20__factory = ERC20__factory;
ERC20__factory.bytecode = _bytecode;
ERC20__factory.abi = _abi;
//# sourceMappingURL=ERC20__factory.js.map